export default function CsharpExplicitCasting() {
  return (
    <h2>Csharp Explicit Casting</h2>
  );
}
